// Colognes - Ranked by Popularity & Sales
// Difficulty: DIFFICULT - Fragrance culture knowledge required

export const colognesData = [
  { id: 1, name: "Sauvage (Dior)", rank: 1, image: "/images/colognes/sauvage.png" },
  { id: 2, name: "Bleu de Chanel", rank: 2, image: "/images/colognes/bleu_de_chanel.png" },
  { id: 3, name: "Acqua di Gio (Armani)", rank: 3, image: "/images/colognes/acqua_di_gio.png" },
  { id: 4, name: "Cool Water (Davidoff)", rank: 4, image: "/images/colognes/cool_water.png" },
  { id: 5, name: "Le Male (JPG)", rank: 5, image: "/images/colognes/le_male.png" },
  { id: 6, name: "1 Million (Paco Rabanne)", rank: 6, image: "/images/colognes/1_million.png" },
  { id: 7, name: "Aventus (Creed)", rank: 7, image: "/images/colognes/aventus.png" },
  { id: 8, name: "Eros (Versace)", rank: 8, image: "/images/colognes/eros.png" },
  { id: 9, name: "The One (D&G)", rank: 9, image: "/images/colognes/the_one.png" },
  { id: 10, name: "Polo (Ralph Lauren)", rank: 10, image: "/images/colognes/polo.png" },
  { id: 11, name: "Fahrenheit (Dior)", rank: 11, image: "/images/colognes/fahrenheit.png" },
  { id: 12, name: "Light Blue (D&G)", rank: 12, image: "/images/colognes/light_blue.png" },
  { id: 13, name: "Invictus (Paco Rabanne)", rank: 13, image: "/images/colognes/invictus.png" },
  { id: 14, name: "Spicebomb (Viktor & Rolf)", rank: 14, image: "/images/colognes/spicebomb.png" },
  { id: 15, name: "Terre d'Hermès", rank: 15, image: "/images/colognes/terre_dhermes.png" },
  { id: 16, name: "Boss Bottled (Hugo Boss)", rank: 16, image: "/images/colognes/boss_bottled.png" },
  { id: 17, name: "CK One (Calvin Klein)", rank: 17, image: "/images/colognes/ck_one.png" },
  { id: 18, name: "Y (YSL)", rank: 18, image: "/images/colognes/ysl_y.png" },
  { id: 19, name: "Dylan Blue (Versace)", rank: 19, image: "/images/colognes/dylan_blue.png" },
  { id: 20, name: "Obsession (Calvin Klein)", rank: 20, image: "/images/colognes/obsession.png" },
  { id: 21, name: "Eternity (Calvin Klein)", rank: 21, image: "/images/colognes/eternity.png" },
  { id: 22, name: "Nautica Voyage", rank: 22, image: "/images/colognes/nautica_voyage.png" },
  { id: 23, name: "Fierce (A&F)", rank: 23, image: "/images/colognes/fierce.png" },
  { id: 24, name: "Baccarat Rouge 540 (MFK)", rank: 24, image: "/images/colognes/baccarat_rouge.png" },
  { id: 25, name: "Oud Wood (Tom Ford)", rank: 25, image: "/images/colognes/oud_wood.png" },
];
